module.exports = __webpack_public_path__ + "public/9a09e086022586bb96a802047566991b.woff";